module.exports = __webpack_public_path__ + "img/background-modal-old-or-new-patient.66a5a70b.png";